export const paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "m7 12.0009 8.0012-8.0007 1.4142 1.4142-6.587 6.5866 6.5859 6.5868L15 20.002l-8-8.0011z" } }];
export const iconName = 'chevron-left';
export const chevronLeft = { iconName, paths };
export default paths;
